var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('el-tag',{attrs:{"size":_vm.size,"type":"success"}},[_vm._v("开启")]):_c('el-tag',{attrs:{"size":_vm.size,"type":"danger"}},[_vm._v("停止月捐")])}
var staticRenderFns = []

export { render, staticRenderFns }